import type { IkeAction } from '../action';
import { IkeEnvironment } from '../const/environment';
import type { IkeServiceConfig } from '../service';

export interface AwsLogs {
	/** Base64 gzip encoded json */
	data: string;
}

export const IkeLogEnvironment = {
	...IkeEnvironment,
	LAMBDA: 'lambda' as const,
	ECS: 'ecs' as const,
	UNKNOWN: 'unknown' as const,
};

export type IkeLogEnvironment =
	| (IkeEnvironment & typeof IkeLogEnvironment.LAMBDA)
	| typeof IkeLogEnvironment.ECS
	| typeof IkeLogEnvironment.UNKNOWN;

export interface AwsLogsData {
	messageType: 'DATA_MESSAGE' | 'CONTROL_MESSAGE';
	/** AWS Account number */
	owner: string;
	/** AWS Cloudwatch log group for the log message */
	logGroup: string;
	/** AWS Cloudwatch log stream for the log message */
	logStream: string;
	/* matched subscription filters that caused the event to be sent to the logshipper */
	subscriptionFilters: string[];
	/* a list of AWS log events */
	logEvents: AwsLogEvent[];
}

export interface AwsLogEvent {
	id: string;
	/* milliseconds since the unix epoch */
	timestamp: string;
	message: string;
}

export interface IkeServiceLogShipperRequest {
	awslogs: AwsLogs;
}

export interface IkeServiceLogShipperResponse {}

export type IkeServiceLogShipperUrl = '/v1/ike/service/logshipper';

export interface IkeServiceLogShipperAction extends IkeAction<
	IkeServiceLogShipperRequest,
	IkeServiceLogShipperResponse,
	IkeServiceLogShipperUrl
> {}

export interface IkeServiceLogShipper extends IkeServiceConfig<'ikegps_cloudwatchlogs', IkeServiceLogShipperAction> {}
